import * as React from "react";
import formatDate from "dateformat";
import CardContent from "../../../../ui-library/content-card/card-content";
import ContentCard from "../../../../ui-library/content-card/content-card";
import CardHeading from "../../../../ui-library/content-card/card-heading";
import CardSubHeading from "../../../../ui-library/content-card/card-sub-heading";
import { AskAboutQuery_SourceData } from "../../../../../../graphql-types";
import SourceLink from "../../../../ui-library/source-link/source-link";
import { EventCategory } from "../../../../../utils/analytics";
import { formatData, getColorByCase } from "./fireplots-helper";
import styles from "./fireplots.styles";

export interface FirePlotData {
  name: string;
  abbreviation: string;
  latest: {
    date: string;
    totalCases: number;
    averageNewCases: number;
  };
  data:
    | {
        date: string;
        averageNewCases: number;
      }[]
    | null;
}

interface FirePlotProps {
  countryName: string;
  data: FirePlotData[];
  sources: AskAboutQuery_SourceData[];
}

const FirePlot: React.FC<FirePlotProps> = ({ countryName, data, sources }) => {
  const auData = formatData(data);

  const { states, days, columns } = auData;

  const casesContent = (cases: number[]) =>
    cases.map((c, di) => (
      <div key={di} css={getColorByCase(c)}>
        {c < 1000 ? c : `${Math.round(c / 100) / 10}k`}
      </div>
    ));

  const width = columns.length * 50;

  return (
    <ContentCard>
      <CardContent>
        <CardHeading>
          Case numbers per location across {countryName}
        </CardHeading>
        <CardSubHeading>
          Fireplot chart shows a rolling 7 day average of {countryName} new
          COVID-19 cases over the last 16 weeks.
        </CardSubHeading>

        <div css={styles.table}>
          <div css={[styles.row, styles.header]} style={{ minWidth: width }}>
            <div>Date</div>
            {states.map((s) => (
              <div key={s}>{s}</div>
            ))}
          </div>
          <div css={styles.row} style={{ minWidth: width }}>
            <div css={styles.bodyHeader}>
              {days.map((d, di) => (
                <div key={di}>{formatDate(d, "dd mmm")}</div>
              ))}
            </div>
            {columns.map((cases, i) => (
              <div key={i} css={styles.bodyColumn}>
                {casesContent(cases)}
              </div>
            ))}
          </div>
        </div>

        <SourceLink
          sources={sources}
          isDataOnly={true}
          eventCategory={EventCategory.CountryPage}
        />
      </CardContent>
    </ContentCard>
  );
};

export default FirePlot;
